"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILTER_TYPE = exports.FILTER_DELAY = void 0;
var FILTER_TYPE = {
  TEXT: 'TEXT',
  SELECT: 'SELECT',
  MULTISELECT: 'MULTISELECT',
  NUMBER: 'NUMBER',
  DATE: 'DATE'
};
exports.FILTER_TYPE = FILTER_TYPE;
var FILTER_DELAY = 500;
exports.FILTER_DELAY = FILTER_DELAY;